const DEFAULT_PRODUCTION_ORIGIN = 'https://gnegnegne.fr';

function hasWindow() {
  return typeof window !== 'undefined' && typeof window.location !== 'undefined';
}

export function getRuntimeOrigin() {
  if (hasWindow() && window.location.origin) {
    return window.location.origin;
  }

  return process.env.NODE_ENV === 'development' ? '' : DEFAULT_PRODUCTION_ORIGIN;
}

export function getSocketOrigin() {
  return process.env.NODE_ENV === 'development' ? '' : getRuntimeOrigin();
}

const runtimeUrls = {
  getRuntimeOrigin,
  getSocketOrigin,
};

export default runtimeUrls;
